import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue";
var _hoisted_1 = { class: "max-h-auto" };
var _hoisted_2 = {
    "transition-duration": "0.5s",
    "origin-top": true,
    "item-selector": ".artwork-tile",
    class: "max-w-7xl before:box-inherit after:box-inherit content"
};
var _hoisted_3 = { class: "grid grid-cols-3 gap-4" };
var _hoisted_4 = { class: "bg-nba-desert-light flex justify-center items-center pt-32 pb-32 pr-40 pl-40" };
var _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-b border-nba-desert-dark" }, null, -1);
var _hoisted_6 = [
    _hoisted_5
];
var _hoisted_7 = ["href"];
var _hoisted_8 = ["src", "alt", "onLoad"];
var _hoisted_9 = { class: "text-center pt-4" };
var _hoisted_10 = ["href"];
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'press.list',
    props: {
        press: null
    },
    setup: function (__props) {
        var props = __props;
        var imagesStatus = ref([]);
        var onImgLoad = function (index) {
            imagesStatus.value[index] = true;
        };
        return function (_ctx, _cache) {
            var _directive_masonry_tile = _resolveDirective("masonry-tile");
            var _directive_masonry = _resolveDirective("masonry");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.press, function (article) {
                            return _withDirectives((_openBlock(), _createElementBlock("div", {
                                key: article.PressID,
                                class: "artwork-tile border border-gray-200 p-2 m-2 bg-white"
                            }, [
                                _withDirectives(_createElementVNode("div", _hoisted_4, _hoisted_6, 512), [
                                    [_vShow, !_unref(imagesStatus)[article.PressID]]
                                ]),
                                _createElementVNode("a", {
                                    class: "img-link",
                                    href: '/press/article/' + article.PressID
                                }, [
                                    _withDirectives(_createElementVNode("img", {
                                        loading: "lazy",
                                        class: "w-full",
                                        src: 'https://media.newbloodart.com/press/' + article.PressPicFile,
                                        alt: article.PressTitle,
                                        onLoad: function ($event) { return (onImgLoad(parseInt(article.PressID))); }
                                    }, null, 40, _hoisted_8), [
                                        [_vShow, _unref(imagesStatus)[article.PressID]]
                                    ])
                                ], 8, _hoisted_7),
                                _createElementVNode("h2", _hoisted_9, [
                                    _createElementVNode("a", {
                                        href: '/press/article/' + article.PressID
                                    }, [
                                        _createTextVNode(_toDisplayString(article.PressTitle) + " ", 1),
                                        _createElementVNode("small", null, _toDisplayString(article.PressDate), 1)
                                    ], 8, _hoisted_10)
                                ])
                            ])), [
                                [_directive_masonry_tile]
                            ]);
                        }), 128))
                    ])
                ])), [
                    [_directive_masonry]
                ])
            ]));
        };
    }
});
